import Task from "../../../core/model2/task/task"
import AppTaskView from "../app"
import taskView_checkTimeReportAccess from "./check-time-report-access"

export default function taskView_startPauseTimer(task?: Task) {

    if (!taskView_checkTimeReportAccess()) {
        return
    }

    if (!task) {
        const app : AppTaskView = gd.getApp() as unknown as AppTaskView
        task = app.task
    }

    if (gd.taskTimers.isTimerActive(task.id)) {
        gd.taskTimers.pauseTimer(task.id)
    } else {
        gd.taskTimers.startTimer(task)
    }
    gd.bus.triggerEvent('task-view:time-tracking')
}